<nav class="navbar navbar-expand-xxl navbar-dark shadow w-100">
    <div class="container-fluid">
        <span class="navbar-brand px-3 prevent-select"><i class="bi bi-grid-fill me-1"></i>{{currentRoute}}</span>
        <div class="ms-auto w-fit-content row text-end align-content-center align-items-center px-3">
            <div class="col-sm col-12 text-center text-light">
                <div><strong>{{user.FirstName}} {{user.LastName}}</strong></div>
                <div class="user-role">{{user.RoleName}}</div>
            </div>
            <i class="w-fit-content bi-person-circle fs-3 text-light mx-3"></i>
            <button class="mx-auto btn btn-light w-fit-content px-2 h-100" name="signout" (click)="signout()">Sign Out</button>
        </div>
    </div>
</nav>